import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardLayout } from './DashboardLayout';
import { Tabs, TabsList, TabsTrigger } from './ui/tabs';
import { useEntityStore, PERSONAL_VIEW_OPTIONS } from '../store';
import { dashboardPathForScope } from '../lib/scopeNavigation';

// Shared layout for all Personal scope pages. Wraps content in
// DashboardLayout and renders the person sub-selector at the top.
// Every Personal section page uses this so the selector is never
// duplicated across pages.

export function PersonalLayout({ children }) {
  const navigate = useNavigate();
  const { personalView, setPersonalView } = useEntityStore();
  const showSelector = PERSONAL_VIEW_OPTIONS.length > 1;

  // Same rule as the scope picker and the entity sub-selector: switching the
  // in-scope sub-selector lands on that scope's dashboard, so a person switch
  // made from a different Personal page (e.g. Spendings) doesn't leave stale
  // data for the newly selected person on screen.
  const handlePersonalViewChange = (view) => {
    setPersonalView(view);
    navigate(dashboardPathForScope('personal'));
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Person sub-selector (segmented control), hidden when only one option */}
        {showSelector && <Tabs
          value={personalView}
          onValueChange={handlePersonalViewChange}
          data-testid="personal-view-selector"
        >
          <TabsList>
            {PERSONAL_VIEW_OPTIONS.map((opt) => (
              <TabsTrigger
                key={opt.key}
                value={opt.key}
                data-testid={`personal-view-${opt.key}`}
              >
                {opt.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </Tabs>}

        {children}
      </div>
    </DashboardLayout>
  );
}
